import React from 'react';
import { Card, CardContent, CardFooter, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Check, Info } from 'lucide-react';
const PLANS = [
  {
    name: 'Quick Setup',
    price: 'Fixed Price',
    description: 'Bespoke implementation or one-off audit for your existing systems.',
    features: [
      'Infrastructure Health Check',
      'Config Tuning (Nginx/DB)',
      'Security Hardening',
      'Observability Setup',
      '14-Day Post-Project Help'
    ]
  },
  {
    name: 'Hourly Support',
    price: 'Flexible',
    description: 'On-demand expertise for maintenance and growth projects.',
    features: [
      'Direct Developer Access',
      'K8s/Linux Maintenance',
      'Ongoing Performance Tuning',
      'Custom CI/CD Pipelines',
      'Emergency Troubleshooting'
    ]
  },
  {
    name: 'Custom Projects',
    price: 'Bespoke',
    description: 'End-to-end development or large migrations managed by me.',
    features: [
      'Full Backend Development',
      'Bare-metal to Cloud Migration',
      'Database Re-architecture',
      'Custom Tooling Creation',
      'Long-term Technical Roadmap'
    ]
  }
];
export function Pricing() {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-20">
      <div className="text-center mb-16 space-y-4">
        <h2 className="text-3xl md:text-5xl font-bold tracking-tight">Engagement Models</h2>
        <p className="text-muted-foreground max-w-2xl mx-auto text-lg">
          Flexible ways I can support your project.
        </p>
      </div>
      <div className="grid md:grid-cols-3 gap-8">
        {PLANS.map((plan) => (
          <Card key={plan.name} className="flex flex-col border-border/50">
            <CardHeader>
              <CardTitle className="text-2xl">{plan.name}</CardTitle>
              <div className="text-3xl font-bold py-2">{plan.price}</div>
              <CardDescription>{plan.description}</CardDescription>
            </CardHeader>
            <CardContent className="flex-1">
              <ul className="space-y-3">
                {plan.features.map(feature => (
                  <li key={feature} className="flex items-start gap-2 text-sm">
                    <Check className="w-5 h-5 text-blue-500 shrink-0" />
                    <span className="text-muted-foreground">{feature}</span>
                  </li>
                ))}
              </ul>
            </CardContent>
            <CardFooter>
              <Button className="w-full h-12" variant="outline" asChild>
                <a href="#contact">Get in Touch</a>
              </Button>
            </CardFooter>
          </Card>
        ))}
      </div>
      <div className="mt-12 p-6 bg-secondary/50 rounded-2xl flex items-center justify-center gap-4 text-sm text-muted-foreground">
        <div className="bg-primary/10 p-2 rounded-full">
          <Info className="w-4 h-4 text-primary" />
        </div>
        <span>Need a small proof-of-concept? I often take on trial tasks for startups on a challenging hourly rate.</span>
      </div>
    </div>
  );
}